/* ═══ SIMULE SEU FRETE — [2026-08-19] ═══════════════════════════════════════
   A regra de frete da Éttore é fechada, não cotada: grátis acima de R$ 499;
   abaixo, o valor e o prazo da tabela "Frete Fixo" da Yampi (9,90 / 19,90,
   prazo por destino — ver `calcula`). A conta é local, sem depender de
   carrinho montado; só a cidade vem do ViaCEP.

   🪤 O TOTAL COMPARADO COM OS R$ 499 É O DO CONJUNTO ESCOLHIDO. A página tem
     combos ("Só esta peça", "Com a Pequena", "Com a Boluda e a Pequena") e o
     preço muda ao trocar. Ler só o preço do anúncio faria a simulação mentir
     justamente para quem gasta mais e TEM direito ao frete grátis. */
(function () {
  'use strict';
  var caixa = document.querySelector('[data-frete]');
  if (!caixa) return;
  var campo = caixa.querySelector('[data-frete-cep]');
  var bt = caixa.querySelector('[data-frete-bt]');
  var res = caixa.querySelector('[data-frete-res]');
  var LIMITE = parseInt(caixa.getAttribute('data-limite'), 10) || 49900;

  function centavos(txt) {
    if (!txt) return 0;
    var m = String(txt).replace(/[^\d,.]/g, '').replace(/\.(?=\d{3}\b)/g, '');
    var n = parseFloat(m.replace(',', '.'));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  /* o preço que está VALENDO na tela: a opção de conjunto marcada vence o
     preço do anúncio, porque é ela que vai para o carrinho.
     🪤 O SELETOR DE CONJUNTO NÃO É `input[type=radio]` — foi o meu primeiro
       palpite e a página devolveu zero. É `.kit` com a classe `.on`, e o preço
       mora em `data-preco` já formatado ("R$ 509,00"). Procurar pelo controle
       que eu ESPERAVA em vez do que EXISTE deixaria a simulação sempre presa
       no preço da peça avulsa — e ela mentiria justo para quem monta combo,
       passa dos R$ 499 e tem direito ao frete grátis. */
  /* 🔴 A QUANTIDADE NÃO ENTRAVA NA CONTA — [2026-09-13], ponto 04 da auditoria do Codex,
     reproduzido: 2 Naras (R$ 778) com CEP de SP respondiam "R$ 9,90", e acima de R$ 499 é
     grátis (ele confirmou a regra hoje: 9,90 Sul/Sudeste, 19,90 demais, grátis ≥ 499, por
     pedido). O valor do frete não muda com a quantidade — o que muda é cruzar o limite. */
  function quantidade() {
    var q = document.querySelector('[data-qtd]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function totalAtual() {
    var kit = document.querySelector('[data-kits] .kit.on');
    if (kit) {
      var v = centavos(kit.getAttribute('data-preco'));
      if (!v) { var f = kit.querySelector('.v b'); v = centavos(f ? f.textContent : ''); }
      if (v > 0) return v * quantidade();
    }
    /* [2026-09-12] `[data-eop-preco]` primeiro: é o gancho que o motor de opções e o
       kit reescrevem. `.preco` é o bloco INTEIRO ("R$ 319,00R$ 449,00−29%") e só
       acertava por sorte do parseFloat parar no primeiro número. */
    var p = document.querySelector('[data-eop-preco], [data-preco-fim], .pfim, .preco');
    return centavos(p ? p.textContent : '') * quantidade();
  }

  function moeda(c) {
    return 'R$ ' + (c / 100).toFixed(2).replace('.', ',');
  }

  /* [2026-09-12] aqui vivia `barra()`, a régua "Faltam R$ X para o frete grátis": o Liquid perdeu
     `data-frete-preenche`/`data-frete-falta` em 02/09 e a função voltava no primeiro `if`. Saiu. */

  /* ═══ [2026-09-30] PREÇO E PRAZO DA TABELA "FRETE FIXO" DA YAMPI ═══════════
     A tabela mora no `ettore-gaveta.js` (`window.EttoreFrete`), que o
     theme.liquid carrega em toda página — um lugar só para as 58 faixas.
     Antes: 9,90/19,90 por região e "previsão de 3 a 7 dias úteis" para todos,
     o que era falso no Norte e Nordeste (Manaus 24, Salvador 9).
     📏 "PREVISÃO" VOLTA A SER "CHEGA EM ATÉ": a regra de 25/08 dizia que a
       palavra voltaria quando o prazo viesse de quem entrega. Agora vem — é o
       número da própria tabela do checkout, sem somar nada.
     O destino fica guardado por CEP: trocar kit ou quantidade refaz só a
     conta do grátis, sem consultar o ViaCEP de novo. */
  var ultimo = null;

  function escreve(d) {
    var F = window.EttoreFrete;
    res.hidden = false;
    if (d.erro) {
      res.className = 'frete-r ruim';
      res.textContent = 'CEP não encontrado. Confira os 8 números.';
      return;
    }
    res.className = 'frete-r';
    var onde = F.lugar(d);
    if (!d.dias) {
      res.innerHTML = (onde ? onde + ' · ' : '') + 'frete e prazo calculados no checkout';
      return;
    }
    var valor = totalAtual() >= LIMITE ? '<b>Frete grátis</b>' : '<b>' + moeda(d.preco) + '</b>';
    res.innerHTML = (onde ? onde + ' · ' : '') + valor + ' · ' + F.prazo(d);
  }

  function calcula() {
    var cep = (campo.value || '').replace(/\D/g, '');
    res.hidden = false;
    if (cep.length !== 8) {
      res.className = 'frete-r ruim';
      res.textContent = 'Digite os 8 números do CEP.';
      return;
    }
    if (!window.EttoreFrete) {
      res.className = 'frete-r';
      res.textContent = 'Frete e prazo calculados no checkout.';
      return;
    }
    if (ultimo && ultimo.cep === cep) return escreve(ultimo);
    res.className = 'frete-r';
    res.textContent = 'Consultando o CEP…';
    window.EttoreFrete.destino(cep).then(function (d) {
      ultimo = d;
      if (!d.erro) { try { localStorage.setItem('ettore-cep', JSON.stringify(d)); } catch (e) {} }
      escreve(d);
    });
  }

  campo.addEventListener('input', function () {
    var v = campo.value.replace(/\D/g, '').slice(0, 8);
    campo.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
  });
  campo.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calcula(); } });
  bt.addEventListener('click', calcula);

  /* trocar de conjunto refaz a conta na hora — se a resposta já está na tela,
     deixá-la desatualizada é pior que não ter mostrado nada */
  function refaz() {
    setTimeout(function () {
      if (!res.hidden && (campo.value || '').replace(/\D/g, '').length === 8) calcula();
    }, 60);
  }

  var kits = document.querySelector('[data-kits]');
  if (kits) kits.addEventListener('click', refaz);

  /* ⚠️ TROCAR A VARIANTE TAMBÉM MUDA O VALOR — [2026-08-21], junto com o
     seletor de cor. Hoje nenhum produto do catálogo cruza os R$ 499 ao trocar
     de variante (os pendentes vão de 289 a 319, a Dupla de 519 a 569), então
     a resposta na tela não chega a mentir. Mas o dia em que uma faixa cruzar,
     ela mentiria em silêncio: a pessoa veria "faltam R$ X para o frete grátis"
     calculado sobre outra variante. Um ouvinte agora custa uma linha. */
  document.addEventListener('ettore:variante', refaz);
  /* mudar a quantidade (digitando ou pelos botões −/+) refaz a conta; os botões mudam o
     `value` por JS sem disparar `input`, por isso o clique também é ouvido */
  document.addEventListener('input', function (e) { if (e.target && e.target.matches('[data-qtd]')) refaz(); });
  document.addEventListener('click', function (e) { if (e.target && e.target.closest('[data-mais], [data-menos]')) refaz(); });
})();
